let menuLoadedFlag = false;

export function isMenuLoaded() {
  return menuLoadedFlag;
}

export function markMenuLoaded() {
  menuLoadedFlag = true;
}

export function resetMenuCache() {
  menuLoadedFlag = false;
}
